import AuthenticationStore from '@/Authentication/authentication.store';
const authenticationModule = {
    store: AuthenticationStore
};
export default authenticationModule;
